export enum MimetypeEnum {
  Pdf = 'application/pdf',
  Json = 'application/json',
  Csv = 'text/csv',
  Xls = 'application/vnd.ms-excel',
  Xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
}
